import React from "react";
import { cn } from "../../lib/utils";
import LanguageSwitcher from "./LanguageSwitcher";
import PageZoomControl from "./PageZoomControl";

/** Fixed bottom-right stack: zoom (above) + language switcher. */
function FloatingTools({ className }) {
  return (
    <div className={cn("flex flex-col items-center gap-1.5", className)}>
      <PageZoomControl />
      <LanguageSwitcher />
    </div>
  );
}

export default FloatingTools;
